import type { RouteRecordRaw } from 'vue-router'
import AuthLayout from '@/layouts/AuthLayout.vue'
import Login from '@/views/auth/login.vue'
import Reset from '@/views/auth/reset.vue'
import ResetPassword from '@/views/auth/reset-password.vue'

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/auth',
    meta: { layout: AuthLayout, middleware: ['guest'], title: 'ورود / ثبت نام' },
    children: [
      {
        path: 'login',
        name: 'auth-login',
        component: Login,
        meta: { title: 'ورود' },
      },
      {
        path: 'reset-password',
        name: 'auth-reset-password',
        component: ResetPassword,
        meta: { title: 'بازیابی رمز عبور' },
      },
      {
        path: 'reset',
        name: 'auth-reset',
        component: Reset,
        meta: { title: 'بازنشانی حساب' },
      },
    ],
  },
]

export default authRoutes
